import {iframeResize} from 'iframe-resizer';

import PageComponent from '../../common/component/page-component';

class ConfiguratorIframe extends PageComponent {
	// constructor({
	// 	root,
	// 	element,
	// }) {
	// 	super({root: root, element: element});
	// }

	prepare() {
		console.log('prepare configurator iframe');
		this.iframe = this.element.querySelector(this.dataSelector('iframe'));
		if (this.iframe) {
			console.log('iframeResize', iframeResize);
			this.resizer = iframeResize(
				{
					log: true,
					heightCalculationMethod: 'bodyOffset', //'taggedElement',
				},
				this.iframe
			);
		}
	}
}

export default ConfiguratorIframe;
